export const CONNECT = 'WEBSOCKET/CONNECT';
export const DISCONNECT = 'WEBSOCKET/DISCONNECT';
export const GET_CURRENT = 'WEBSOCKET/GET_CURRENT_STATE';
export const GET_HISTORY = 'WEBSOCKET/GET_HISTORY';
export const CURRENT_STATE = 'CURRENT_STATE';
export const HISTORY = 'HISTORY';
export const STATE_UPDATE = 'STATE_UPDATE';
